import { WhiteCard } from "./white.card";
import "./cards.scss";

interface SideImageCardProps {
  children: React.ReactNode;
  imgSrc: string;
  loading?: boolean;
}
export function SideImageCard({
  children,
  imgSrc,
  loading,
}: SideImageCardProps) {
  return (
    <WhiteCard className="side-image-card">
      <div className="side-image-card-content">
        {loading && <div>Chargement...</div>}

        {!loading && children}
      </div>
      <div className="side-image-card-image-container">
        <img className="h-full right-0" src={imgSrc} alt="" />
      </div>
    </WhiteCard>
  );
}
